export const BottomSheetSnapPoints = {
  Search: ['85%'],
} as const
